// import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

// import { useNavigate } from 'react-router-dom';
import FooterConsulting from '../../Components/shared/Footer/FooterConsulting';
import NavbarConsulting from '../../Components/shared/Navbar/NavbarConsulting';
// import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import { DrawFigure2, DrawIcon19, DrawIcon20, DrawIcon21, DrawIcon22 } from '../../data/SVGConsulting';
// import {DrawImageHomeExpert26, DrawImageHomeExpert31, DrawImageHomeExpert32, DrawImageHomeExpert33, DrawImageHomeExpert34 } from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';
import imgSection from './../../Assets/ConsultingHomePage/section_4_Consulting.png';
function AboutUsConsulting() {

    const {device}=useWindowSize();
    // const navigate=useNavigate();
    const { i18n } = useTranslation();
    usePersistedLanguage();

    return (

        <>
            <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',width:'100%',background:'white',height:'fit-content'}}>
                <NavbarConsulting />

                <div style={{display:'flex',flexDirection:'column',gap:'65px',marginTop:device == 'desktop'?'65px':'0px', alignItems:'center',alignSelf:'stretch'}}>
                    <div
                        className='frame105HomePage'
                        id='apropos'
                        style={{width:'90%',height:'auto'}}
                    >
                        <div className='frame106HomePage'>
                            <div
                                className='frame107HomePage'
                                style={{width:device=='desktop'?'55%':'100%'}}
                            >
                                <div className='frame108HomePage'>
                                    <h3 className='frame101HomePage'>
                                        {i18n.t('Votre Partenaire de Confiance en Consulting IT')}
                                    </h3>
                                    <h6 className='frame110HomePage'>
                                        {i18n.t('Chez High Tech Hires, nous sommes spécialisés dans le conseil en technologies de l\'information, avec pour objectif d\'aider les entreprises à maximiser leur potentiel digital. Fondée sur des valeurs de collaboration, d\'innovation et de performance, notre société accompagne ses clients dans la gestion, la transformation et l\'optimisation de leurs systèmes informatiques.')}
                                    </h6>
                                </div>

                            </div>
                            <div
                                className='frame112HomePage'
                                style={{width:device=='desktop'?'45%':'100%'}}
                            >
                                <DrawFigure2 width={device=='desktop'?'453':'330'}/>
                            </div>

                        </div>
                    </div>
                    <div style={{background:'#E7EAF9',width:'100%',height:device == 'desktop' ? '415px':'auto',alignItems:'center',display:'flex',alignSelf:'center',flexDirection:'column',gap:'24px',padding:'24px'}}>
                        <h2 className='homeExpertf50'>{i18n.t('Notre Mission')} </h2>
                        <div
                            className='homeExpertf46'
                            style={{gridTemplateColumns:'repeat(1, 1fr)',width:'65%'}}
                        >
                            <div
                                className='homeExpertf47'
                                style={{borderColor:'#C3C9F1'}}
                            >
                                <div className='homeExpertf48'>

                                    <p className='homeExpertf49'>
                                        {i18n.t('Nous croyons que chaque entreprise est unique, avec ses propres défis et ambitions. C\'est pourquoi nous nous engageons à fournir des solutions sur mesure qui répondent à vos besoins spécifiques. Que ce soit pour améliorer l\'efficacité de vos opérations, intégrer des solutions cloud, renforcer la sécurité de vos données ou accompagner votre transformation digitale, nous mettons notre expertise à votre service pour faire face aux défis technologiques de demain.')}                               </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className='homeExpertf18'
                        id='Nvaleurs'
                    >
                        <h2 className='homeExpertf50'>{i18n.t('Nos Valeurs')} </h2>
                        <div
                            className='homeExpertf45'
                            style={{padding:'0px'}}
                        >
                            <div
                                className='homeExpertf51'
                                style={{
                                    display: 'grid',
                                    flex: '1 1 0%',
                                    gridTemplateColumns: device=='desktop'?'repeat(2, minmax(0, 1fr))':'repeat(1, minmax(0, 1fr))',
                                    //background: '#F8F9FA',
                                    //borderBottom: '1px solid #C3C9F1',
                                    height: 'fit-content',
                                    width:'100%',
                                }}
                            >
                                <div className='homeExpertf52'>
                                    <DrawIcon19 />
                                    <div className='homeExpertf48'>
                                        <h5 className='homeExpertf16'>
                                            {i18n.t('Collaboration')}
                                        </h5>
                                        <p className='homeExpertf49'>
                                            {i18n.t('Nous croyons en la puissance de la collaboration. Nous travaillons en partenariat avec nos clients et nos experts pour atteindre des objectifs communs.')}
                                        </p>
                                    </div>
                                </div>

                                <div
                                    className='homeExpertf52'
                                    style={{background:'#E3F5EA'}}
                                >
                                    <DrawIcon20 />
                                    <div className='homeExpertf48'>
                                        <h5 className='homeExpertf16'>
                                            {i18n.t('Excellence')}
                                        </h5>
                                        <p className='homeExpertf49'>
                                            {i18n.t('Nous nous engageons à fournir des services de qualité exceptionnelle. Nous recherchons constamment l’excellence dans tout ce que nous faisons.')}
                                        </p>
                                    </div>
                                </div>

                            </div>

                            <div
                                className='homeExpertf51'
                                style={{
                                    display: 'grid',
                                    flex: '1 1 0%',
                                    gridTemplateColumns: device=='desktop'?'repeat(2, minmax(0, 1fr))':'repeat(1, minmax(0, 1fr))',
                                    //background: '#F8F9FA',
                                    //borderBottom: '1px solid #C3C9F1',
                                    height: 'fit-content',
                                    width:'100%',
                                }}
                            >
                                <div
                                    className='homeExpertf52'
                                    style={{background:'#E3F5EA'}}
                                >
                                    <DrawIcon21 />
                                    <div className='homeExpertf48'>
                                        <h5 className='homeExpertf16'>
                                            {i18n.t('Innovation')}
                                        </h5>
                                        <p className='homeExpertf49'>
                                            {i18n.t('Nous sommes une entreprise axée sur l’innovation. Nous adoptons les nouvelles technologies et les meilleures pratiques pour rester à la pointe de notre secteur.')}
                                        </p>
                                    </div>
                                </div>

                                <div className='homeExpertf52'>
                                    <DrawIcon22 />
                                    <div className='homeExpertf48'>
                                        <h5 className='homeExpertf16'>
                                            {i18n.t('Responsabilité')}
                                        </h5>
                                        <p className='homeExpertf49'>
                                            {i18n.t('Nous assumons la responsabilité de nos actions. Nous tenons nos promesses et nous nous engageons à répondre aux besoins de nos clients ')}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div
                        id='Nequipe'
                        className='homeExpertf18'
                        style={{width:device=='desktop'?'64%':'94%'}}
                    >
                        <h2 className='homeExpertf50'>{i18n.t('Notre Equipe')} </h2>
                        <div
                            className='homeExpertf45'
                            style={{padding:'0px'}}
                        >
                            <div style={{display:'flex',flexDirection:'row',gap:'24px'}}>
                                {/* <div style={{display:'flex',flexDirection:'column',gap:'24px'}}>
                                    <img src={Rectangle_1} />
                                    <img src={Rectangle_2} />
                                    <img src={Rectangle_3} />
                                </div>
                                <div style={{display:'flex',flexDirection:'column',gap:'24px'}}>
                                    <img src={Rectangle_4} />
                                    <img src={Rectangle_5} />
                                </div>
                                {device=='desktop' &&
                                <div style={{display:'flex',flexDirection:'column',gap:'24px'}}>
                                    <img src={Rectangle_6} />
                                    <img src={Rectangle_7} />
                                </div>
                                } */}
                                <img src={imgSection} />
                            </div>
                        </div>
                        <h6
                            className='frame110HomePage'
                            style={{textAlign:'left'}}
                        >
                            {i18n.t('Nous croyons fermement que notre équipe est notre atout le plus précieux. Nous sommes fiers de travailler avec une équipe de professionnels hautement qualifiés, passionnés par la technologie et déterminés à fournir des solutions exceptionnelles à nos clients. L’une des caractéristiques distinctives de notre équipe est sa diversité. Nos collaborateurs apportent un éventail de compétences et d’expériences qui couvrent l’ensemble du spectre numérique. La collaboration est au cœur de notre culture. Nous croyons que les meilleures solutions naissent de la synergie d’esprits créatifs travaillant ensemble. De plus, Notre équipe est dévouée à la satisfaction de nos clients. Chaque projet est une occasion d’excellence, et nous nous engageons à fournir des solutions de qualité qui répondent aux besoins uniques de chaque client.')}
                        </h6>
                    </div>
                </div>
                <FooterConsulting
                    styleProps={{background: '#005E23',
                    }}
                />
            </div>
        </>
    );
}

export default AboutUsConsulting;